export default __webpack_public_path__ + "static/media/mesos.d9563028.svg";